import {config} from '../config';

export default {
    getAuthBackground: () => config.data.image.authBackground,
};
